import Toaster from '../../alerts/toaster.js';


export default class AbstractParams 
{

	constructor() 
	{
		this.cols = [];
		this.rows = [];
		this.type = null;
		this.id = null;
		this.chart_options = {
			height:400, 
			width:600,
		};

		// Private data

		var required = ['cols', 'rows', 'type', 'id'];
		var missing  = [];
		var empty    = [];

		this._getRequiredParams = function() 
		{
			return required;
		}

		this._setMissingParam = function(param) 
		{
			if (missing.indexOf(param) > -1) {
				missing.push(param);
			}
		}

		this._getMissingParams = function() 
		{
			return missing;
		}

		this._setEmptyParam = function(param) 
		{
			if (empty.indexOf(param) > -1) {
				empty.push(param);
			}
		}

		this._getEmptyParams = function() 
		{
			return empty;
		}

	}


	checkParams() 
	{
		const required = this._getRequiredParams();

		required.forEach((param) => {
			if (!this.hasOwnProperty(param)) {
				this._setMissingParam(param);
			}
			if (this.hasOwnProperty(param)) {
				if (!this[param].length) {
					this._setEmptyParam(param);
				}
			}
		}, this);
	}


	hasMissingParams() 
	{
		const missing = this._getMissingParams();

		return missing.length ? true : false;
	}


	hasEmptyParams() 
	{
		const empty = this._getEmptyParams();

		return empty.length ? true : false;
	}


	hasErrors() 
	{
		return this.hasMissingParams() || this.hasEmptyParams();
	}


	toastErrors(type, errors=[]) 
	{
		if (errors.length > 0) {
			
			$.each(errors,(index, error) => {

				(new Toaster).toast('Error', error, 'error'); 
			
			});
		}
	}


	checkForErrors() 
	{
		this.checkParams();

		if (this.hasMissingParams()) {

			this.toastErrors('Missing', this._getMissingParams());
		
		}
		
		if (this.hasEmptyParams()) {
		
			this.toastErrors('Empty', this._getEmptyParams());
		
		}
	}

}